export const FAMILLE_TACHE_PRIORITE = {
	AUTRES: 0,
	DES: 10,
	SOINS_PROTECTION: 20,
	PREP_PLANCHE: 30,
	IMPLANTATION: 35,
	SEMIS: 40,
	RECOLTE: 50
}